import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService, PrimeIcons } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { OdaAtFirestore } from 'src/app/models/odaAtFirestore.model';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { environment } from 'src/environments/environment';
import { onSnapshot } from 'firebase/firestore';
import { UtilService } from 'src/app/services/util.service';
import { Menu } from 'primeng/menu';
import { OdaService } from 'src/app/services/oda.service';
import { CreaOdaComponent } from './crea/crea-oda';
import { ModificaOdaComponent } from './modifica/modifica-oda';
import { FiltroOda } from 'src/app/models/filtroODA';
import { ExcelService } from 'src/app/services/excelService.service';
import { StoricoOda } from 'src/app/models/oda.storico.model';
import { StoricoOdaComponent } from './storico/storico-oda.component';

@Component({
    templateUrl: './oda.component.html',
    styleUrls: ['./oda.component.css'],
    providers: [DialogService, ConfirmationService, MessageService],

})
export class ODAComponent implements OnInit, OnDestroy {
    protected isLoadingResults:boolean = false;
    protected filterIsSet:boolean = false;
    protected showDeleteConfirmation:boolean = false;
    protected showOdaAlert:boolean = false;
    protected listaODA:OdaAtFirestore[] ;
    protected listaODAOriginale:OdaAtFirestore[] ;
    protected selectedODA:OdaAtFirestore ;
    protected numeroTotaleOda:number =0 ;
    protected mostraOdaCompletati: boolean = false;
    protected odaOltreSoglia: OdaAtFirestore[] = [];

    @ViewChild("menuAzioni", { static: true }) azioniMenu: Menu;
    @ViewChild("menuAzioniTiered", { static: true }) azioniMenuTiered: Menu;

    protected menuAzioniItems!: MenuItem[];
    protected filtriODA: FiltroOda = new FiltroOda();
 
    public isDirigenteFirmaPacchetti: boolean   = false;
    public isDemo: boolean = false;

    private collection_oda:string = environment.firebase.collection_oda;
    
    private ref: DynamicDialogRef;

    @ViewChild("odaDT", { static: true }) odaDT: any;
    
    constructor(
        private logger: NGXLogger,
        public firestore: AngularFirestore,
        public utilService:UtilService,
        public odaService:OdaService,
        private dialogService: DialogService,
        private messageService: MessageService,
        private router: Router,
        private excelService: ExcelService,
    ) {
      if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_PACCHETTI"
      ) {
        this.isDirigenteFirmaPacchetti = true;
      }else if(localStorage.getItem("ruolo") && localStorage.getItem("ruolo") === "DEMO"){
        this.isDemo = true;
      }
    }

    ngOnDestroy(): void {
    }

    ngOnInit() {
         
        this.loadODA();
    }

    async openCaricaAzioni(  event: any, oda:OdaAtFirestore ): Promise<void> {
      this.selectedODA = oda;
      this.loadAzioni(event, oda);
      this.azioniMenuTiered.toggle(event);
    }

   
    loadAzioni(event:any, oda:OdaAtFirestore){
      this.menuAzioniItems = [];
      if(this.isDirigenteFirmaPacchetti){
        this.menuAzioniItems.push(
          {
            label: "Storico",
            style: {  'font-size': '13px'},
            icon: PrimeIcons.HISTORY,
            command: () => this.apriStorico(oda)
          },{
            label: "BEF",
            style: {  'font-size': '13px'},
            icon: PrimeIcons.SHOPPING_CART,
            command: () => this.apriBEF(oda)
          },
          {
            label: "Pratiche",
            style: {  'font-size': '13px'},
            icon: "pi pi-clipboard",
            items:[
              {
                label: "Fase I",
                style: {  'font-size': '13px'},
                icon: 'icona-fase-1',
                command: () => this.mostraPratiche(oda, '1')
              },
              {
                label: "Fase II",
                style: {  'font-size': '13px'},
                icon: 'icona-fase-2',
                command: () => this.mostraPratiche(oda, '2')
              },
              {
                label: "Fase III",
                style: {  'font-size': '13px'},
                icon: 'icona-fase-3',
                command: () => this.mostraPratiche(oda, '3')
              }
            ]
         
          },);
      }else {

     
      this.menuAzioniItems.push(
        {
          label: "Storico",
          style: {  'font-size': '13px'},
          icon: PrimeIcons.HISTORY,
          command: () => this.apriStorico(oda)
        },{
          label: "BEF",
          style: {  'font-size': '13px'},
          icon: PrimeIcons.SHOPPING_CART,
          command: () => this.apriBEF(oda)
        },
        {
          label: "Pratiche",
          style: {  'font-size': '13px'},
          icon: "pi pi-clipboard",
          items:[
            {
              label: "Fase I",
              style: {  'font-size': '13px'},
              icon: 'icona-fase-1',
              command: () => this.mostraPratiche(oda, '1')
            },
            {
              label: "Fase II",
              style: {  'font-size': '13px'},
              icon: 'icona-fase-2',
              command: () => this.mostraPratiche(oda, '2')
            },
            {
              label: "Fase III",
              style: {  'font-size': '13px'},
              icon: 'icona-fase-3',
              command: () => this.mostraPratiche(oda, '3')
            }
          ]
       
        },
      );
      if(oda.dataCompletamento==null && oda.importoImpegnato==0 && oda.importoEmEmesse==0){
        this.menuAzioniItems.push(
          {
            label: "Modifica",
            style: { 'font-weight': 'bold', 'font-size': '13px'},
            icon: PrimeIcons.PENCIL,
            command: () => this.modificaOda(oda),
            disabled: this.isDemo
          },
          {
            label: "Elimina",
            style: { 'font-weight': 'bold', 'font-size': '13px'},
            icon: PrimeIcons.TRASH,
            command: () => this.eliminaOda(oda),
            disabled: this.isDemo
          },
        );
      }
    }
      
      
    }

    onMostraCompletatiChange(newValue: boolean): void {
      // Esegui la logica che desideri quando il valore di mostraCompletati cambia
      console.log('Valore di mostraCompletati cambiato:', newValue);
      this.mostraOdaCompletati = newValue
      this.loadODA();
  }

    loadODA(){
        this.logger.info("[ODA] LOADING ODA @ "+ this.collection_oda);
        this.isLoadingResults = false;
        const collectionRef = this.firestore.collection(this.collection_oda).ref;
        let query;
        if(!this.mostraOdaCompletati){
          query = collectionRef.where("dataCompletamento", "==", null).orderBy("numero");
        }else{
          query = collectionRef.orderBy("numero");
        }
        
        onSnapshot(query, (qs) => {
          this.logger.info("[ODA] onSnapshot dei dati --> dovrei rifiltrare!");
          this.listaODA = [];
          this.listaODAOriginale = [];
          this.isLoadingResults = false;
          this.numeroTotaleOda = qs.docs.length;
          qs.forEach((doc) => {
            let oda = doc.data() as OdaAtFirestore;
            /* if(oda.numero==7010215529){
              this.logger.info(JSON.stringify(oda));
            } */
            
            this.listaODA.push(oda);
            this.listaODAOriginale.push(oda);
            //che su ODA oltre il 90%
            if(oda.dataCompletamento==null && oda.percentualeResidua <=10){
              this.odaOltreSoglia.push(oda);
              // Temporaneamente disabilitato
              //this.showOdaAlert = true;
            }
          });
        });
  
    }

    getImportoDovuto(oda:OdaAtFirestore):number{
      return (oda.importoDovutoFase1 ?? 0) + (oda.importoDovutoFase2 ?? 0) + (oda.importoDovutoOpereExtra ?? 0) + (oda.importoDovutoFase3 ?? 0);
    }

    filtraODA(event: any){
      this.odaDT.filterGlobal(event.target.value, 'contains');
      
    }

    filtraPerBando(oda:OdaAtFirestore){
      if(this.filtriODA.bando && this.filtriODA.bando === oda.bando){
        this.filtriODA.bando = null;
        if(!this.filtriODA.impresa && !this.filtriODA.lotto){
          this.listaODA = this.listaODAOriginale;
          this.filterIsSet = false;
        }
        
      }else{
        this.filtriODA.bando = oda.bando;
        this.listaODA = this.listaODA.filter((odaFS: OdaAtFirestore) => {
          if (odaFS.bando==oda.bando){
            if(this.filtriODA.impresa){
              if(odaFS.azienda === this.filtriODA.impresa){
                return odaFS;
              }else{
                return null;
              }
            }else{
              return odaFS;
            }
            
          }else{
            return null;
          }
        });
        this.filterIsSet = true;
      }
      
/* 
      this.logger.info("--> filtraPerBando "+oda.bando);
      const currentFilter = this.odaDT.filters.global?.value || ''; // Recupera il filtro globale corrente
      this.logger.info("--> currentFilter " + currentFilter);
      if(currentFilter ===oda.bando){
        this.odaDT.clear();
        this.filterIsSet = false;
      }else{
        const newFilter = currentFilter 
        ? `${currentFilter} && ${oda.bando}`  // Combina i filtri con un separatore
        : oda.bando;
        this.logger.info("--> newFilter " + newFilter);
        this.odaDT.filterGlobal(newFilter, 'contains');
        this.filterIsSet = true;
      } */
     
/* 
      if(!this.filterIsSet){
        this.filterIsSet = true;
       
        const newFilter = currentFilter 
          ? `${currentFilter} && ${oda.bando}`  // Combina i filtri con un separatore
          : oda.bando;
          this.logger.info("--> newFilter " + newFilter);
  
        this.odaDT.filterGlobal(newFilter, 'contains');
        //this.odaDT.filterGlobal(oda.bando, 'contains');
      }else if(!currentFilter){
        this.filterIsSet = false;
        this.odaDT.clear();
      } */
      
    }
    filtraPerAzienda(azienda:String){
      if(this.filtriODA.impresa && this.filtriODA.impresa === azienda.toString()){
        this.filtriODA.impresa = null;
        if(!this.filtriODA.bando && !this.filtriODA.lotto){
          this.listaODA = this.listaODAOriginale;
          this.filterIsSet = false;
        }
      }else{
        this.filtriODA.impresa = azienda.toString();

        this.listaODA = this.listaODA.filter((odaFS: OdaAtFirestore) => {
          if (odaFS.azienda==azienda.toString()){
            if(this.filtriODA.bando){
              if(odaFS.bando === this.filtriODA.bando){
                return odaFS;
              }else{
                return null;
              }
            }else{
              return odaFS;
            }
            
          }else{
            return null;
          }
        });
        this.filterIsSet = true;
      }
     

      /* this.logger.info("--> filtraPerAzienda "+azienda);
      const currentFilter = this.odaDT.filters.global?.value || ''; // Recupera il filtro globale corrente
      this.logger.info("--> currentFilter " + currentFilter);

      if(currentFilter ===azienda){
        this.odaDT.clear();
        this.filterIsSet = false;
      }else{
        const newFilter = currentFilter 
        ? `${currentFilter} && ${azienda}`  // Combina i filtri con un separatore
        : azienda;
        this.logger.info("--> newFilter " + newFilter);
        this.odaDT.filterGlobal(newFilter, 'contains');
        this.filterIsSet = true;
      } */
     /*  if(!this.filterIsSet){
        this.filterIsSet = true;
        this.odaDT.filterGlobal(azienda, 'contains');
        this.listaODA
      }else if(!currentFilter){
        this.filterIsSet = false;
        this.odaDT.clear();
      } */
      
    }

    filtraPerLotto(lotto:string){
      if(this.filtriODA.lotto && this.filtriODA.lotto === lotto){
        this.filtriODA.lotto = null;
        if(!this.filtriODA.bando && !this.filtriODA.impresa){
          this.listaODA = this.listaODAOriginale;
          this.filterIsSet = false;
        }
      }else{
        this.filtriODA.lotto = lotto;

        this.listaODA = this.listaODA.filter((odaFS: OdaAtFirestore) => {
          if (odaFS.lotti.indexOf(lotto)!=-1){
            if(this.filtriODA.bando){
              if(odaFS.bando === this.filtriODA.bando){
                return odaFS;
              }else{
                return null;
              }
            }else if(this.filtriODA.impresa){
                if(odaFS.azienda === this.filtriODA.impresa){
                  return odaFS;
                }else{
                  return null;
                }
            }else{
              return odaFS;
            }
            
          }else{
            return null;
          }
        });
        this.filterIsSet = true;
      }
      /* this.logger.info("--> filtraPerLotto "+lotto);
      const currentFilter = this.odaDT.filters.global?.value || ''; // Recupera il filtro globale corrente
      this.logger.info("--> currentFilter " + currentFilter);
      if(currentFilter ===lotto){
        this.odaDT.clear();
        this.filterIsSet = false;
      }else{
        const newFilter = currentFilter 
        ? `${currentFilter} && ${lotto}`  // Combina i filtri con un separatore
        : lotto;
        this.logger.info("--> newFilter " + newFilter);
        this.odaDT.filterGlobal(newFilter, 'contains');
        this.filterIsSet = true;
      } */

      /* if(!this.filterIsSet){
        this.filterIsSet = true;
        this.listaODA = this.listaODA.filter(oda => oda.lotti?.includes(lotto));

       
      }else if(!currentFilter){
        this.filterIsSet = false;
        this.listaODA = this.listaODAOriginale;
      } */
      
    }
    removeFilter(){
      this.filterIsSet = false;
      this.filtriODA.bando = null;
      this.filtriODA.impresa = null;
      this.filtriODA.lotto = null;
      //this.odaDT.clear();
      this.listaODA = this.listaODAOriginale;
    }

    mostraPratiche(oda:OdaAtFirestore, fase:string){
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+oda.idBando+'/fase-'+fase+'/oda/'+oda.numero]));

    }

    apriStorico(oda:OdaAtFirestore){
      this.ref = this.dialogService.open(StoricoOdaComponent, {
        data :{
          oda:oda
        },
        header: "Storico dell'Ordine di Acquisto "+ oda.numero,
        width:  "60%" ,
        height: "90%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((confirmNewOda) => {
        if (confirmNewOda && confirmNewOda.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Oda modificato con successo!', life:3000});
          this.loadODA();
        }
      });  
      
      
    }
    apriBEF(oda:OdaAtFirestore){
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['bef/oda/'+oda.numero]));
    }

    scaricaReportOda(){
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
      this.excelService.exportOdaToExcel(this.listaODA, `oda_${formattedDate}.xlsx`);
    }


    modificaOda(oda:OdaAtFirestore){
      this.isLoadingResults = true;
      this.odaService.getById(oda.id.toString()).subscribe( {
          next: (v) => {
            this.logger.info(JSON.stringify(v));
            this.ref = this.dialogService.open(ModificaOdaComponent, {
              data :{
                oda:v
              },
              header: "Modifica ordine di acquisto "+ oda.numero,
              width:  "60%" ,
              height: "40%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
            this.ref.onClose.subscribe((confirmNewOda) => {
              if (confirmNewOda && confirmNewOda.success) {
                this.messageService.add({severity:'success', summary:'', detail:'Oda modificato con successo!', life:3000});
                this.loadODA();
              }
            });  
          },
          error: (e) => {
              this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di recupero dell\'oda da modificare azienda'});
              this.isLoadingResults = false;
          },
          complete: () => {
              this.isLoadingResults = false;
              
          }
      });
    }

    eliminaOda(oda:OdaAtFirestore){
      this.showDeleteConfirmation = true;
      this.selectedODA = oda;
    }

    confermaEliminazioneOda(){
      this.showDeleteConfirmation = false;
      this.isLoadingResults = true;
      this.odaService.elimina(this.selectedODA.id.toString()).subscribe( {
          next: (v) => {
  
          },
          error: (e) => {
              this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di eliminazione dell\'ordine di acquisto'});
              this.isLoadingResults = false;
          },
          complete: () => {
              this.messageService.add({severity:'success', summary:'', detail:'Ordine di acquisto eliminato!', life:5000});
            this.loadODA();
              this.isLoadingResults = false;
              
          }
      });
    }

    openCreaODADialog(){
       this.ref = this.dialogService.open(CreaOdaComponent, {
        header: "Nuovo Ordine di acquisto",
        width:  "70%" ,
        height: "60%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((confirmNewOda) => {
        if (confirmNewOda && confirmNewOda.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Oda creato con successo!', life:3000});
          this.loadODA();
        }
      });  

  } 
}
